import { Button } from "@/components/ui/button";
import { TID } from "@/constants/testIds";
import { FileSpreadsheet, Upload } from "lucide-react";
import { fmt, fmtMoney } from "./_shared";

export function AmpolTab({ reports, onOpenImport, canImport }) {
  return (
    <div className="space-y-3">
      <div className="rounded-lg border border-amber-200 bg-amber-50 p-3 flex items-start gap-3">
        <FileSpreadsheet className="w-5 h-5 text-amber-700 mt-0.5" />
        <div className="flex-1 text-sm text-amber-900">
          <div className="font-semibold">Ampol Monthly Reports</div>
          <p className="text-xs mt-0.5">CSV uploads are auto-parsed → per-vehicle CO₂e calculated (Australian NGA factor) → rolled up into Scope 1 emissions per BU. Ampol API auto-sync will be wired once credentials are provided.</p>
        </div>
        {canImport && (
          <Button data-testid={TID.sustAmpolImportOpen} onClick={onOpenImport} size="sm" className="bg-emerald-800 hover:bg-emerald-900 text-white">
            <Upload className="w-3.5 h-3.5 mr-1.5" /> Import CSV
          </Button>
        )}
      </div>
      <div className="rounded-lg border border-slate-200 bg-white overflow-x-auto">
        <div className="grid grid-cols-6 gap-2 min-w-[640px] px-4 py-2.5 text-[11px] uppercase tracking-wider text-white bg-emerald-800">
          <div>Month</div>
          <div>Filename</div>
          <div className="text-right">Rows</div>
          <div className="text-right">Litres</div>
          <div className="text-right">Cost inc GST</div>
          <div className="text-right">CO₂e (kg)</div>
        </div>
        <div className="divide-y divide-slate-100">
          {reports.length === 0 && <div className="p-10 text-center text-sm text-slate-500">No Ampol reports imported yet. Click "Import CSV" to upload the first month.</div>}
          {reports.map((r) => (
            <div key={r.id} data-testid={TID.sustAmpolReportRow(r.id)} className="grid grid-cols-6 gap-2 min-w-[640px] px-4 py-3 text-sm items-center">
              <div className="font-mono text-slate-700">{r.report_month}</div>
              <div className="text-slate-800 truncate text-xs">{r.filename}</div>
              <div className="text-right text-slate-700">{fmt(r.row_count)}</div>
              <div className="text-right">{fmt(r.total_litres, 1)} L</div>
              <div className="text-right text-slate-700">{fmtMoney(r.total_cost)}</div>
              <div className="text-right font-semibold text-rose-700">{fmt(r.total_co2e_kg)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
